import _ from "lodash";

export default store => next => action => {
    if (_.isFunction(action)) {
        action(store);
    } else {
        return next(action);
    }
};
